// extracted by mini-css-extract-plugin
export default {"container":"g3-z","heading":"h3-z","links":"i3-z","copy":"j3-z","subCopy":"k3-z","linksLeft":"l3-z","linksCenter":"m3-z","linksRight":"n3-z","link":"o3-z","onlyLink":"p3-z"};